import { isArray } from "lodash";
export var valueIsEmpty = function (value) {
  if (isArray(value)) {
    return value.length === 0;
  }
  return !value;
};